var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditGuestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0);}.b,.c{fill:#6b6b95;}.c{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-710.771 -434.395)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M715,457.711a.8.8,0,0,1,.861-.711h13.769a.724.724,0,1,1,0,1.421H715.861A.8.8,0,0,1,715,457.711Z",
    transform: "translate(0 -2.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M726.776,438.873a.836.836,0,0,0-1.215,0l-.755.784,3.081,3.2.755-.783a.917.917,0,0,0,0-1.261Zm-8.414,7.473,5.229-5.428,3.081,3.2-5.229,5.427Zm-1.215,1.261-.43.446v3.2H719.8l.43-.446Zm7.2-9.995a2.51,2.51,0,0,1,3.644,0l1.866,1.936a2.749,2.749,0,0,1,0,3.784l-8.843,9.18a1.687,1.687,0,0,1-1.215.523h-3.081A1.752,1.752,0,0,1,715,451.251v-3.2a1.818,1.818,0,0,1,.5-1.261Z",
    transform: "translate(0 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGuestIcon);
export default __webpack_public_path__ + "static/media/edit-guest-icon.b6bf9aa73485ecdf0dd89f1974cd6958.svg";
export { ForwardRef as ReactComponent };